export enum CoordinateSystem {
  GEOGRAPHIC = 'EPSG:4326',
  WEB_MERCATOR = 'EPSG:3857',
  BGS2005 = 'EPSG:25835',
  BG2005CAD = 'BGS2005CAD',
  UTM35 = 'EPSG:32635',
  UTM34 = 'EPSG:32634',
  BG_703 = 'BG:703',
  BG_705 = 'BG:705',
  BG_707 = 'BG:707',
  BG_709 = 'BG:709',
  BG_3024 = 'BG:3024',
  BG_3027 = 'BG:3027',
  BG50324 = 'BG:50324',
  BG50327 = 'BG:50327',
  BG50621 = 'BG:50621',
  BG50627 = 'BG:50627'
}
